import script from "./AdjustmentGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./AdjustmentGuide.vue?vue&type=script&setup=true&lang=js"

import "./AdjustmentGuide.vue?vue&type=style&index=0&id=a55021c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a55021c8"]])

export default __exports__